import Draw from 'ol/interaction/Draw'
import { Vector as VectorSource } from 'ol/source'
import GeoJSON from '@/utils/geoJson'
import { get as getProjection } from 'ol/proj'
import VectorLayer from 'ol/layer/Vector'
import { Fill, Style } from 'ol/style'

export default class DrawInteraction {
  constructor ({
    map,
    drawType = 'Polygon',
    maxPoints = undefined,
    geom = null
  } = {}) {
    this.map = map

    this.callbacks = []

    this.source = new VectorSource({
      wrapX: false,
      features: geom === null
        ? null
        : GeoJSON.readFeatures(JSON.parse(geom), {
          dataProjection: getProjection('EPSG:2056'),
          featureProjection: getProjection('EPSG:2056')
        })
    })
    this.source.on('addfeature', (event) => {
      this._doCallback({
        name: 'onFeaturesChange',
        event,
        geom: this.source.getFeatures()[0].getGeometry()
      })
    })

    this.drawInteraction = new Draw({
      source: this.source,
      type: drawType,
      maxPoints
    })

    this._setDrawLayer()
    this.map.addInteraction(this.drawInteraction)
  }

  _getDrawLayer () {
    return this.drawLayer
  }

  _setDrawLayer () {
    this.drawLayer = new VectorLayer({
      source: this.source,
      style: new Style({
        fill: new Fill({
          color: 'rgba(214, 58, 58, 0.3)'
        })
      })
    })
  }

  clearDrawLayer () {
    this._getDrawLayer().getSource().clear()
  }

  release () {
    this.map.removeInteraction(this.drawInteraction)
  }

  onFeaturesChange (callback) {
    this.callbacks.onFeaturesChange = callback
  }

  _doCallback ({
    name,
    event,
    geom
  } = {}) {
    const callback = this.callbacks[name]
    if (typeof (callback) === 'undefined') return
    callback(event, JSON.parse(GeoJSON.writeGeometry(geom)))
  }
}
